import Card from "../../shared/Card"
const ThinkinginReact = () => {
    return (
        <div className="demo-container">
            <Card title="React Project Planning" subtext="Project Planning" description="Remember certain key principles like Single Responsibility, Identify States, Lifting the State Up, Inverse Data Flow."/>
        </div>
    )
}

export default ThinkinginReact